<template>
    <CargarMapa
      :configMapa="configMapa"
      apiKey="AIzaSyBC352P_nCrnC7GTGYfBceGMKD0fZQe0aE" 
    >
  
      <template slot-scope="{ google, map }">
        <Marcadores
          :validateA="validateA"
          :newAutocomplete="newAutocomplete"
          v-for="marker in markers"
          :key="marker.id"
          :marker="marker"
          :google="google"
          :map="map"
        />
      </template>
  
    </CargarMapa>
</template>
<script>

 
  import CargarMapa from "./loadMap";
  import Marcadores from "./markers";
  import { configMapa } from "@/constants/configMapa";
 
  export default {
    components: {
      CargarMapa,
      Marcadores
    },
    props : {
      lat:{
        required: true
      },
      lng:{
        required: true
      },
      validateA:{
        required:true
      },
      newAutocomplete:{
        required:true
      }
    },
    data() {
      return {
        markers: [
          {
            id: "0",
            position: { lat: this.lat, lng: this.lng },
            title: "Aguascalientes"
          }
        ]
      };
    },
 
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      },
 
      mapCenter() {
        return this.markers[0].position;
      }
    }
  };
  
</script>